import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "syncFilled"
const SyncFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M17.966 6.034C19.236 7.304 20.067 8.945 20.34 10.72 20.612 12.494 20.312 14.31 19.482 15.902S17.334 18.779 15.723 19.57C14.78 20.035 13.764 20.314 12.73 20.404L14.163 21.837 12.837 23.163 9.174 19.5 12.837 15.837 14.163 17.163 12.814 18.51C13.534 18.42 14.237 18.212 14.896 17.889 16.149 17.272 17.173 16.273 17.819 15.034S18.699 12.384 18.486 11.004 17.628 8.347 16.64 7.359zM14.826 4.5 11.538 7.788 10.212 6.462 11.185 5.49C10.465 5.579 9.762 5.788 9.104 6.11 7.85 6.728 6.826 7.727 6.18 8.966 5.535 10.204 5.3 11.616 5.513 12.996S6.372 15.653 7.36 16.641L6.033 17.966C4.764 16.696 3.933 15.055 3.66 13.28S3.688 9.69 4.518 8.098C5.348 6.507 6.665 5.221 8.276 4.43 9.22 3.965 10.236 3.685 11.27 3.595L10.212 2.538 11.538 1.212z" />
        </svg>
      }
    </span>
  )
}
export default SyncFilledIcon
